import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksExportablePurchaseOrderConstructor,
  QuickBooksExportablePurchaseOrder,
} from './QuickBooksExportablePurchaseOrder'

export const QuickBooksExportablePurchaseOrderConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksExportablePurchaseOrderConstructor>({
    procurifyPoNumber: Factory.each(() => faker.random.number()),
    poNumber: Factory.each(() => `PO-${faker.random.number(9999)}`),
    date: Factory.each(() => faker.date.past()),
    purchaserName: Factory.each(
      () => `${faker.name.firstName()} ${faker.name.lastName()}`
    ),
    vendorName: Factory.each(() => faker.company.companyName()),
    total: Factory.each(() => faker.commerce.price()),
    purchasedCurrency: null,
    uuid: Factory.each(() => faker.random.uuid()),
    stagedForExport: false,
  })

export const QuickBooksExportablePurchaseOrderFactory = EntityFactory(
  QuickBooksExportablePurchaseOrder,
  QuickBooksExportablePurchaseOrderConstructorFactory
)
